export default __webpack_public_path__ + "static/media/404.7db89497.svg";